import { supabase } from '../lib/supabaseClient';

export async function getHiddenVybeIds(userId: string): Promise<Set<string>> {
  try {
    const { data, error } = await supabase
      .from('user_hidden_vybes')
      .select('vybe_id')
      .eq('user_id', userId);

    if (error) throw error;
    return new Set((data || []).map(d => d.vybe_id));
  } catch (error) {
    console.error('Error fetching hidden vybes:', error);
    return new Set();
  }
}

export async function hideVybe(userId: string, vybeId: string, reason?: string) {
  try {
    const { error } = await supabase
      .from('user_hidden_vybes')
      .upsert({
        user_id: userId,
        vybe_id: vybeId,
        reason: reason || 'manual',
        hidden_at: new Date().toISOString()
      });

    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error hiding vybe:', error);
    return { success: false, error };
  }
}

export async function unhideVybe(userId: string, vybeId: string) {
  try {
    const { error } = await supabase
      .from('user_hidden_vybes')
      .delete()
      .match({ user_id: userId, vybe_id: vybeId });

    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error unhiding vybe:', error);
    return { success: false, error };
  }
}

export function getLocalHiddenVybes(): Set<string> {
  try {
    const stored = localStorage.getItem('hidden_vybes_local');
    if (!stored) return new Set();
    return new Set(JSON.parse(stored));
  } catch {
    return new Set();
  }
}

export function setLocalHiddenVybes(ids: Set<string>) {
  try {
    localStorage.setItem('hidden_vybes_local', JSON.stringify(Array.from(ids)));
  } catch (error) {
    console.error('Error saving hidden vybes to localStorage:', error);
  }
}

export function hideVybeLocally(vybeId: string) {
  const hidden = getLocalHiddenVybes();
  hidden.add(vybeId);
  setLocalHiddenVybes(hidden);
}

export function unhideVybeLocally(vybeId: string) {
  const hidden = getLocalHiddenVybes();
  hidden.delete(vybeId);
  setLocalHiddenVybes(hidden);
}
